import { render, staticRenderFns } from "./LancamentosModal.vue?vue&type=template&id=5fc68665&scoped=true&"
import script from "./LancamentosModal.vue?vue&type=script&lang=js&"
export * from "./LancamentosModal.vue?vue&type=script&lang=js&"
import style0 from "./LancamentosModal.vue?vue&type=style&index=0&id=5fc68665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc68665",
  null
  
)

export default component.exports